/**
 * @file shop-monogram.ts
 * @description Монограмма магазина — «значок» магазина, пока нет логотипа
 * (phase19.31, SC19; uiux-design §2).
 *
 * Две буквы из названия на плитке «цвета магазина». Цвет — из
 * ФИКСИРОВАННОГО набора 8 цветов по хэшу id магазина: не из темы (иначе
 * магазин менял бы цвет вместе с темой) и без красного и янтарного (их
 * путали бы со статусами). Белый текст на любом цвете набора — контраст
 * не ниже 4,5 (значения в комментариях). Набор — данные, как метки стадий;
 * менять его — значит перекрасить все магазины.
 */

/** Цвета плитки монограммы (белый текст — контраст). */
export const SHOP_MONOGRAM_COLORS: readonly string[] = [
  "#2563eb", // синий — 5,17
  "#7c3aed", // фиолетовый — 5,70
  "#0f766e", // бирюзовый — 5,47
  "#15803d", // зелёный — 5,02
  "#0369a1", // голубой — 5,93
  "#be185d", // малиновый — 6,04
  "#4338ca", // индиго — 7,90
  "#475569", // графит — 7,58
];

/** Стабильный хэш строки (FNV-1a, 32 бита) — один магазин всегда одного цвета. */
function hashString(value: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/** Цвет плитки по id магазина. */
export function shopMonogramColor(shopId: string): string {
  return SHOP_MONOGRAM_COLORS[hashString(shopId) % SHOP_MONOGRAM_COLORS.length] ?? "#475569";
}

/**
 * Две буквы: первые буквы двух первых слов («Мёд Алтая» → «МА»); одно
 * слово — его первые две буквы («Chaiberi» → «CH»). Без букв — «?».
 */
export function shopInitials(name: string): string {
  const words = name
    .split(/[\s\-–—_.,«»"']+/u)
    .map((w) => w.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean);
  const [first, second] = words;
  if (!first) return "?";
  const letters = second ? `${first.charAt(0)}${second.charAt(0)}` : first.slice(0, 2);
  return letters.toLocaleUpperCase("ru-RU");
}
